import { useEffect, useRef } from 'react';
import SubmitAndCancelButton from '../../../components/button/SubmitAndCancelButton';
import Checkbox from '../../../components/inputs/Checkbox';
import Input from '../../../components/inputs/Input';
import { ProjectPutRequest } from '../../../types/project/ProjectPutRequest';
import { focusNextInput } from '../../../utils/focusNextInput';
import YmdPicker from '../../../components/picker/YmdPicker';
import { format } from 'date-fns';
import TableBaseButton from '../../../components/button/TableBaseButton';
import { useNavigate } from 'react-router-dom';

interface EditProjectRowProps {
  item: ProjectPutRequest;
  onChange: (key: keyof ProjectPutRequest, value: any) => void;
  onEditSubmitButtonClick: (id: number) => void;
  onEditCancelButtonClick: () => void;
}

const EditProjectRow = ({
  item,
  onChange,
  onEditSubmitButtonClick,
  onEditCancelButtonClick,
}: EditProjectRowProps) => {
  const navigate = useNavigate();
  const inputsRef = useRef<(HTMLInputElement | HTMLButtonElement)[]>([]);

  // 最初の input に自動フォーカス
  useEffect(() => {
    if (inputsRef.current[0]) {
      inputsRef.current[0].focus();
    }
  }, []);

  return (
    <>
      <td>
        <Input
          value={item.projectNumber}
          onChange={(e) => onChange('projectNumber', e.target.value)}
          ref={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          onKeyDown={(e) => focusNextInput(e, inputsRef, 0)}
        />
      </td>
      <td>
        <Input
          value={item.projectName}
          onChange={(e) => onChange('projectName', e.target.value)}
          ref={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          onKeyDown={(e) => focusNextInput(e, inputsRef, 1)}
        />
      </td>
      <td>
        <Input
          value={item.clientName}
          onChange={(e) => onChange('clientName', e.target.value)}
          ref={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          onKeyDown={(e) => focusNextInput(e, inputsRef, 2)}
        />
      </td>
      <td>
        <YmdPicker
          selectedDate={new Date(item.startDate)}
          setSelectedDate={(date) =>
            onChange('startDate', date ? format(date, 'yyyy-MM-dd') : '')
          }
          placeholder="年/月/日"
          ref={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          onKeyDown={(e) => focusNextInput(e, inputsRef, 3)}
        />
      </td>
      <td>
        <YmdPicker
          selectedDate={new Date(item.endDate)}
          setSelectedDate={(date) =>
            onChange('endDate', date ? format(date, 'yyyy-MM-dd') : '')
          }
          placeholder="年/月/日"
          ref={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          onKeyDown={(e) => focusNextInput(e, inputsRef, 4)}
        />
      </td>
      <td>
        <Checkbox
          checked={item.isUnproductive}
          onChange={(checked) => onChange('isUnproductive', checked)}
          ref={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          onKeyDown={(e) => focusNextInput(e, inputsRef, 5)}
        />
      </td>
      <td>
        <Checkbox
          checked={item.isDairen}
          onChange={(checked) => onChange('isDairen', checked)}
          ref={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          onKeyDown={(e) => focusNextInput(e, inputsRef, 6)}
        />
      </td>
      <td>
        <TableBaseButton
          onClick={() => {
            navigate(`/admin/assignment/${item.id}`);
          }}
          buttonText="参画社員を管理"
          className="btn btn-add-custom"
          ref={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          onKeyDown={(e) => focusNextInput(e, inputsRef, 7)}
        />
      </td>
      <td>
        <TableBaseButton
          onClick={() => {
            navigate(`/admin/projects/${item.id}/costs`);
          }}
          buttonText="費用を管理"
          className="btn btn-add-custom"
          ref={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          onKeyDown={(e) => focusNextInput(e, inputsRef, 8)}
        />
      </td>
      <td className="text-center">
        <SubmitAndCancelButton
          onSubmit={() => onEditSubmitButtonClick(item.id)}
          onCancel={() => onEditCancelButtonClick()}
          onSubmitKeyDown={(e) => focusNextInput(e, inputsRef, 9)}
          onCancelKeyDown={(e) => focusNextInput(e, inputsRef, 10)}
          submitButtonRef={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          cancelButtonRef={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
        />
      </td>
    </>
  );
};

export default EditProjectRow;
